/**
 * @fileoverview This file contains the how to download section.
 */
/**
 * How to download
 * @returns {JSX.Element} ダウンロード方法の JSX element
 */
export function PrivacyPolicy(): JSX.Element {
  return (
    <section className="c-section">
      <h2 className="p-heading-2">プライバシーポリシー</h2>
      <p className="c-text">
        GasLogReaderプライバシーポリシー
        <br />
        本ソフトウェア・プライバシーポリシーは、株式会社ガステックが提供するロギングデータ読み取りソフトウェアGasLogReader(以下本ソフト)から送信される利用者情報とその取扱いについて説明するものです。
        <br />
        本ソフトウェア・プライバシーポリシーの内容をご確認・ご理解したうえで本ソフトをご利用ください。
        <h3 className="p-heading-3">
          ソフト本体からの利用者に関する情報の送信停止/削除とその影響など
        </h3>
        本ソフトは、利用者に関する情報の収集、送信を行っておりません。
        <br />
        個人情報に関する内容を外部へ送信する機能も実装されておりません。
        <h3 className="p-heading-3">株式会社ガステックの個人情報保護方針</h3>
        当社の個人情報保護方針は、下記のURLよりご確認ください。本個人情報保護方針と、本ソフトウェア・プライバシーポリシーが異なる場合には、本ソフトウェア・プライバシーポリシーが優先されるものとします。
        <br />
        <br />
        プライバシーポリシー URL
        <br />
        <a
          href="https://www.gastec.co.jp/files/user/asset/pdf/Privacy_Policy.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://www.gastec.co.jp/files/user/asset/pdf/Privacy_Policy.pdf
        </a>
        <h3 className="p-heading-3">株式会社ガステックの問い合わせ窓口</h3>
        個人情報の取り扱いに関するお問い合わせは下記までご連絡ください。
        <br />
        <br />
        株式会社ガステック 営業本部
        <br />
        〒252-1195
        <br />
        神奈川県綾瀬市深谷中8-8-6
        <br />
        電話:0467-79-3911 FAX:0467-79-3979
        <br />
        Mail:webadmin@gastec.co.jp
        <br />
        <br />
        <br />
        2024年12月23日 施行
      </p>
    </section>
  );
}
